import {
  isMarketplaceHaulsActive,
  isMarketplaceOrdersActive,
  isMarketplaceSellActive,
  isMarketplaceShopActive,
  marketplaceNav,
} from '@/config/marketplaceNav';

export type MarketplaceNavItemId = 'shop' | 'hauls' | 'orders' | 'sell';

export type MarketplaceNavItemView = {
  id: MarketplaceNavItemId;
  href: string;
  label: string;
  icon: string;
};

export function marketplaceNavItems(sellLabel: string): MarketplaceNavItemView[] {
  const items: MarketplaceNavItemView[] = [
    {
      id: 'shop',
      href: marketplaceNav.shop.href,
      label: marketplaceNav.shop.label,
      icon: marketplaceNav.shop.icon ?? 'uil-shop',
    },
  ];
  if (marketplaceNav.hauls) {
    items.push({
      id: 'hauls',
      href: marketplaceNav.hauls.href,
      label: marketplaceNav.hauls.label,
      icon: marketplaceNav.hauls.icon ?? 'uil-search',
    });
  }
  items.push(
    {
      id: 'orders',
      href: marketplaceNav.orders.href,
      label: marketplaceNav.orders.label,
      icon: marketplaceNav.orders.icon ?? 'uil-receipt',
    },
    {
      id: 'sell',
      href: marketplaceNav.sell.href,
      label: sellLabel,
      icon: marketplaceNav.sell.icon ?? 'uil-store',
    },
  );
  return items;
}

export function isMarketplaceNavItemActive(id: MarketplaceNavItemId, pathname: string): boolean {
  switch (id) {
    case 'shop':
      return isMarketplaceShopActive(pathname);
    case 'hauls':
      return isMarketplaceHaulsActive(pathname);
    case 'orders':
      return isMarketplaceOrdersActive(pathname);
    case 'sell':
      return isMarketplaceSellActive(pathname);
    default:
      return false;
  }
}
